import React from 'react';
import { SectionHeading } from '../components/ui/SectionHeading';
import { FAQAccordion } from '../components/ui/FAQAccordion';
import { Card } from '../components/ui/Card';
import { PatientJourneyScroll } from '../components/ui/PatientJourneyScroll';
import { Globe, CheckCircle } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function PatientsPage() {
  const {
    t
  } = useLanguage();
  const faqs = t.patients.faq.items.map(item => ({
    question: item.q,
    answer: item.a
  }));
  return <div className="pt-20" data-id="element-563">
      {/* Hero */}
      <div className="bg-caces-sky py-20" data-id="element-564">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-565">
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-caces-navy mb-4" data-id="element-566">
            {t.patients.hero.title}
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-567">
            {t.patients.hero.subtitle}
          </p>
        </div>
      </div>

      {/* Visual Patient Journey (Replaces old icon grid) */}
      <PatientJourneyScroll data-id="element-568" />

      {/* International Patients */}
      <section className="py-16 bg-caces-navy text-white" data-id="element-569">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-570">
          <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-571">
            <div className="w-full md:w-1/3 flex justify-center" data-id="element-572">
              <Globe size={120} className="text-caces-accent opacity-80" data-id="element-573" />
            </div>
            <div className="w-full md:w-2/3" data-id="element-574">
              <h2 className="font-serif text-3xl font-bold mb-6" data-id="element-575">
                {t.patients.international.title}
              </h2>
              <p className="text-lg text-caces-light mb-6 leading-relaxed" data-id="element-576">
                {t.patients.international.desc}
              </p>
              <ul className="space-y-3 mb-8" data-id="element-577">
                {t.patients.international.list.map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-578">
                    <CheckCircle className="text-caces-accent" size={20} data-id="element-579" />
                    <span data-id="element-580">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Preparation Checklist */}
      <section className="py-16 bg-white" data-id="element-581">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-582">
          <SectionHeading title={t.patients.prep.title} data-id="element-583" />
          <Card className="p-8 bg-gray-50 border-none" data-id="element-584">
            <h3 className="font-serif text-xl font-bold text-caces-navy mb-6" data-id="element-585">
              {t.patients.prep.subtitle}
            </h3>
            <ul className="space-y-4" data-id="element-586">
              {t.patients.prep.list.map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-700" data-id="element-587">
                  <div className="mt-1 w-2 h-2 rounded-full bg-caces-accent flex-shrink-0" data-id="element-588"></div>
                  <span data-id="element-589">{item}</span>
                </li>)}
            </ul>
          </Card>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 bg-white" data-id="element-590">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-591">
          <SectionHeading title={t.patients.faq.title} data-id="element-592" />
          <FAQAccordion items={faqs} data-id="element-593" />
        </div>
      </section>
    </div>;
}